import { render, staticRenderFns } from "./VesselManualForm.vue?vue&type=template&id=0adca57a&"
import script from "./VesselManualForm.vue?vue&type=script&lang=js&"
export * from "./VesselManualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports